import React, { Component } from 'react';
import { Button } from 'reactstrap';
import moment from 'moment';

export class WorkOrderIntTableActiveSmall extends Component {
  static displayName = WorkOrderIntTableActiveSmall.name;

  render() {
    const { workOrders } = this.props;

    if (!workOrders) return null;

    // Use 100dvh for mobile browsers to avoid the address bar shrinking the viewport
    // Add paddingBottom to ensure last card is fully visible above the bottom edge
    return (
      <div
        style={{
          padding: 0,
          margin: 0,
          height: 'calc(100dvh - 120px)',
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          background: '#f5f5f5',
          paddingBottom: 24,
        }}
      >
        {workOrders.map((workorder, i) => (
          <div
            key={workorder.jobId}
            style={{
              background: '#fff',
              borderRadius: 8,
              boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
              margin: '10px 0',
              padding: 12,
              fontSize: 16,
              lineHeight: 1.4,
              maxWidth: 480,
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <div style={{ marginBottom: 6 }}>
              <div
                style={{ fontWeight: 600, color: '#d35400', marginBottom: 6 }}
              >
                Job #{workorder.jobNum}
              </div>
              <div>
                {workorder.finalConfButton !== 'Hide' && (
                  <Button
                    color="primary"
                    className="btn-portal-action"
                    style={{ marginRight: 6, marginBottom: 4, minHeight: '44px', padding: '8px 16px' }}
                    onClick={() => this.props.setData(workorder, true)}
                  >
                    Final Conf
                  </Button>
                )}
                {workorder.endTimeButton !== 'Hide' && (
                  <Button
                    color="primary"
                    className="btn-portal-action"
                    style={{ marginBottom: 4, minHeight: '44px', padding: '8px 16px' }}
                    onClick={() =>
                      this.props.handleEndIntTimeClick(workorder, i, true)
                    }
                  >
                    End Time
                  </Button>
                )}
              </div>
            </div>
            <div style={{ marginBottom: 4 }}>
              <b>Date:</b>{' '}
              {workorder.jobDateTime
                ? moment(workorder.jobDateTime).format('MM/DD/YYYY hh:mm A')
                : ''}
            </div>
            <div style={{ marginBottom: 4 }}>
              <b>Claimant:</b>{' '}
              {workorder.hasClaimantDupWO ? (
                <span style={{ color: 'red' }}>
                  {workorder.clmFirstName} {workorder.clmLastName}
                </span>
              ) : (
                `${workorder.clmFirstName} ${workorder.clmLastName}`
              )}
            </div>
            {workorder.providerName && (
              <div style={{ marginBottom: 4 }}>
                <b>Provider:</b> {workorder.providerName}
              </div>
            )}
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 8,
                marginBottom: 4,
              }}
            >
              <div>
                <b>Chk#:</b> {workorder.intCheckNum}
              </div>
              ]
              <div>
                <b>Chk Date:</b>{' '}
                {workorder.intCheckDate
                  ? moment(workorder.intCheckDate).format('MM/DD/YYYY')
                  : ''}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 8,
                marginBottom: 4,
              }}
            >
              <div>
                <b>Fee:</b>{' '}
                {workorder.intFee == null ? '' : `$${workorder.intFee}`}
              </div>
              <div>
                <b>OT:</b>{' '}
                {workorder.intOTFee == null ? '' : `$${workorder.intOTFee}`}
              </div>
              <div>
                <b>OTH:</b>{' '}
                {workorder.intFeeOther == null
                  ? ''
                  : `$${workorder.intFeeOther}`}
              </div>
              <div>
                <b>Total:</b>{' '}
                {workorder.jobTotal == null ? '' : `$${workorder.jobTotal}`}
              </div>
            </div>
            <div style={{ marginBottom: 4 }}>
              <b>Address:</b> {workorder.aptStreet} {workorder.aptCity}{' '}
              {workorder.aptState} {workorder.aptZip}
            </div>
            {workorder.intApptNotes && (
              <div style={{ marginBottom: 4 }}>
                <b>Appt Directions:</b> {workorder.intApptNotes}
              </div>
            )}

            {workorder.attachmentFileLocationS3 && (
              <div style={{ marginTop: 6 }}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.onDownloadAttachment(
                      workorder.attachmentJobHistoryId,
                      workorder.attachmentFileName
                    );
                  }}
                >
                  Download Attachment
                </a>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }
}
